import axios from 'axios';
import { AxiosRequestConfig } from 'axios';

const baseConfig: AxiosRequestConfig = {
   baseURL: 'https://api.themoviedb.org/3',
   maxBodyLength: 2000000, // 2MB
   maxContentLength: 2000000, // 2MB
};

const cacheFirstConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};

const staleWhileRevalidateConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'stale-while-revalidate',
   },
};

const http = axios.create(baseConfig);

const authRequestInterceptor = (config: AxiosRequestConfig) => {
   const token =
      'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI1NTAyMDUwM2U2MDZhOGQ5YTljZDY2ODkwYmIyOTlkNSIsInN1YiI6IjYzMWZhOWExYjg3YWVjMDA4MjgzZTZjMSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.W2m6Zk9mn87lyctoqjiwCcHQ2oyBKc1LnEIaNbI66jM';
   if (token) {
      config.headers.accept = 'application/json';
      config.headers.Authorization = `Bearer ${token}`;

      return config;
   }
   return config;
};

// TODO: add auth token to request
http.interceptors.request.use(authRequestInterceptor);

export { http, cacheFirstConfig, staleWhileRevalidateConfig };
